module.exports = __webpack_public_path__ + "static/images/logo02.35047601e.png";